import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetFeatureFlagsRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetFeatureFlagsResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getFeatureFlags = (request: GetFeatureFlagsRequest, options?: CashRequestOptions) =>
  post<GetFeatureFlagsRequest, GetFeatureFlagsResponse>('/2.0/cash/get-feature-flags', request, {
    ...options,
    rejectOnError: true,
  })
